import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { baseUrl } from '../../../enum/constant';

const RequestFormList = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const base = baseUrl;
            const response = await axios.get(base + 'api/AllRequestsForm', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            setRequests(response.data.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteRequest = async (id) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this request?');
        if (!confirmDelete) return;

        try {
            const base = baseUrl;
            await axios.delete(`${base}api/delrequestForm/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            setRequests(requests.filter(req => req.id !== id));
        } catch (err) {
            setError(err.message);
        }
    };

    const handleUpdateStatus = async (id, status) => {
        try {
            const base = baseUrl;
            const response = await axios.post(
                `${base}api/StatusReqUpdate/${id}/status`,
                { status },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                }
            );
            setRequests((prevRequests) =>
                prevRequests.map((req) =>
                    req.id === id ? { ...req, status: response.data.data.status } : req
                )
            );
            setMessage('Status updated successfully');
            setTimeout(() => setMessage(null), 3000);
        } catch (err) {
            setError(err.message);
        }
    };

    // Pagination calculations
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentRequests = requests.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(requests.length / itemsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    if (loading) return <div className="mt-md-5 pt-md-5"><div className="mt-md-5"><div className="alert alert-info">Loading...</div></div></div>;
    if (error) return <div className="mt-md-5 pt-md-5"><div className="mt-md-5"><div className="alert alert-danger">Error: {error}</div></div></div>;

    return (
        <div className="cus-dash-container container">
            {message &&
                // <div className="alert alert-success">{message}</div>
                <div class="cus-alert-msg alert-success" role="alert">
                    <div class="icon">
                        ✔
                        {/* <i class="bi bi-check-lg"></i> */}
                    </div>
                    <p class="message mb-0">{message}</p>
                </div>
            }
            <h5 className="mb-4">Enquiry</h5>
            <div style={{ overflowX: "auto" }}>
                <table className="table table-striped dstable">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Email</th>
                            {/* <th>Description</th> */}
                            <th>Wallet ID</th>
                            <th>Attachment</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRequests.map((req) => (
                            <tr key={req.id}>
                                <td>{req.id}</td>
                                <td>{req.email}</td>
                                {/* <td>{req.description}</td> */}
                                <td>{req.wallet_id}</td>
                                <td>
                                    <a
                                        href={`${baseUrl}storage/${req.attachment}`}
                                        // href={`${baseUrl}storage/app/public/${req.attachment}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        View
                                    </a>
                                </td>
                                <td>
                                    {req.status === 0 ? (
                                        <button
                                            className="btn btn-warning btn-sm"
                                            onClick={() => handleUpdateStatus(req.id, 1)}
                                        >
                                            Pending
                                        </button>
                                    ) : (
                                        <button
                                            className="btn btn-success btn-sm"
                                            onClick={() => handleUpdateStatus(req.id, 0)}
                                        >
                                            Completed
                                        </button>
                                    )}
                                </td>
                                <td>
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleDeleteRequest(req.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            <nav>
                <ul className="pagination mt-2">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                    </li>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <li
                            key={index}
                            className={`page-item ${currentPage === index + 1 ? 'active' : ''
                                }`}
                        >
                            <button
                                className="page-link"
                                onClick={() => handlePageChange(index + 1)}
                            >
                                {index + 1}
                            </button>
                        </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default RequestFormList;
